import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { approve_reject_engagement_request } from "../../data/ApiEndpoints";

const validateForm = (formValues) => {
  let errors = {};

  if (!formValues.remarks) {
    errors.remarks = "required!";
  } else if (formValues.remarks?.length < 20) {
    errors.remarks = "required";
  }

  return errors;
};

const ApproveRejectForm = ({
  userInfoData,
  cardName,
  rowData,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const forminitials = {
    remarks: "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    setIsSubmit(false);
    const { name, value } = e.target;

    setFormValues((prevs) => ({
      ...prevs,
      [name]: value,
    }));
  };

  const onSubmit = () => {
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  const handleSubmitForm = async (payload) => {
    const method = "POST";
    const endpoint = approve_reject_engagement_request;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        aprv_rej_description: formValues.remarks || "",
        is_approved: cardName === "reject" ? 2 : 1,
        engagement_id: rowData?.uid || "",
        aprv_rej_by: userInfoData?.uid || userInfoData?.user_id || "",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div
      className={`createNewCTOModalContainer ${
        cardName === "approve" || cardName === "reject"
          ? "mod-width-50p"
          : "mealsModalContainer"
      }`}
    >
      <CommonHeadingNBtns
        title={`${cardName} engagement Request`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer mb30">
        <div className="formInputsGrid oneGridSystem">
          <div className="formInputBox span4">
            <label htmlFor="remarks" className="formInputLabel">
              remarks (min 20 - {formValues.remarks?.length}){" "}
              <span className="required">*</span>
            </label>

            <textarea
              name="remarks"
              className={`formInput ${formErrors.remarks ? "formError" : ""}`}
              placeholder="Enter Remarks"
              value={formValues.remarks}
              onChange={onChangeInput}
            ></textarea>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ApproveRejectForm;
